import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.11.1_713fb40cf4b231dfcf16506806954d9c/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.11.1_713fb40cf4b231dfcf16506806954d9c/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}